var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":'删除'+_vm.title,"width":"400","closable":false},on:{"on-ok":_vm.conformOk,"on-cancel":_vm.cancel},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('p',[_vm._v("\n    确定要删除"+_vm._s(_vm.title)+"吗？")]),_c('p',[_vm._v("删除后无法恢复，请谨慎操作！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }